var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white" }, [
    _c("form", { staticClass: "hideBlockParent" }, [
      _c("div", { staticClass: "form-group mb-4" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "input-group mb-3 d-flex flex-row" },
          [
            _c(
              "el-select",
              {
                staticClass: "input-normal select-danger",
                staticStyle: { flex: "9" },
                attrs: {
                  "value-key": "id",
                  filterable: "",
                  remote: "",
                  placeholder: "Search Company",
                  "remote-method": _vm.search,
                  loading: _vm.searching,
                  "allow-create": "",
                },
                on: { change: _vm.onCompanySelected },
                model: {
                  value: _vm.selectedCompany,
                  callback: function ($$v) {
                    _vm.selectedCompany = $$v
                  },
                  expression: "selectedCompany",
                },
              },
              _vm._l(_vm.foundCompanies, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.website, value: item },
                })
              }),
              1
            ),
            false
              ? _c(
                  "div",
                  {
                    staticClass: "input-group-append",
                    staticStyle: { flex: "1" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        attrs: {
                          id: "inviteForm5",
                          type: "button",
                          "data-toggle": "collapse",
                          href: "#assignForm5",
                          role: "button",
                          "aria-expanded": "false",
                        },
                        on: {
                          click: function ($event) {
                            _vm.createCompanyExpanded =
                              !_vm.createCompanyExpanded
                            _vm.selectedCompany = null
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-user-plus" })]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "row mb-4" }, [
          _c("div", { staticClass: "col mt-2" }, [
            _c(
              "div",
              {
                staticClass: "collapse multi-collapse",
                attrs: { id: "assignForm5" },
              },
              [
                _c("div", { staticClass: "card card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12 form-group" }, [
                      _c("label", [_vm._v("Company Website")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companyInvite.website,
                            expression: "companyInvite.website",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.companyInvite.website },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companyInvite,
                              "website",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "base-button",
            {
              staticClass: "col my-4 btn-block",
              attrs: { type: "primary" },
              on: { click: _vm.handleSubmit },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.createCompanyExpanded ? "Create & Set Company" : "Set"
                )
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("label", [_vm._v("Select Company")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }